import { ActionReducerMap } from '@ngrx/store';
import { UrlParamsState } from './url-params.state';
import { urlParams } from './reducers/url-params.reducer';
import { authentication } from './reducers/authentication.reducer';

/**
 * Config store.
 *
 * https://github.com/ngrx/platform/blob/master/docs/router-store/api.md#navigation-actions
 */
export const reducers: ActionReducerMap<UrlParamsState> = {
    urlParams,
    authentication
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/url-params.store.ts